import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(regs => {
        regs.forEach(r => r.unregister());
      });
    }
  };

  ngOnInit() {
    const isStandalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      (window.navigator as any).standalone === true;

    if (isStandalone) {
      document.body.innerHTML = `
      <div style="
        display:flex;
        align-items:center;
        justify-content:center;
        height:100vh;
        text-align:center;
        font-family:sans-serif;
        padding:20px;">
        <div>
          <h2>این نسخه دیگر پشتیبانی نمی‌شود!</h2>
          <p>لطفاً این اپ را از گوشی خود حذف کرده و از نسخه وب استفاده کنید.</p>
          <p>برای حذف: روی آیکن نگه دارید و Remove را انتخاب کنید.</p>
        </div>
      </div>
    `;
    }
  }
}